<template>
    <v-main class="promoter-payout-page">
        <v-app-bar app flat light color="white">
            <AppbarBackIcon />
            <v-toolbar-title class="font-weight-bold">
                <span>佣金提现</span>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn class="ml-4" color="primary" outlined to="/dash/promoter-payout-list">提现记录</v-btn>
        </v-app-bar>
        <v-container fluid class="content">
            <v-text-field class="form-date" label="收益截止日期" v-model="form.dt_profit_created__lte"></v-text-field>
            <div class="d-flex justify-center">
                <v-btn color="primary" @click="onPreparePayout">准备提现</v-btn>
            </div>
            <v-list class="prepare-list">
                <v-list-item v-for="prepareItem in prepareItemList" :key="prepareItem.currency">
                    <v-row class="prepare-item">
                        <v-col class="prepare-item-cell">
                            <div class="label">币种</div>
                            <div class="value">{{ prepareItem.currency }}</div>
                        </v-col>
                        <v-col class="prepare-item-cell">
                            <div class="label">提现人数</div>
                            <div class="value">{{ prepareItem.promoter_balance_s.length }}</div>
                        </v-col>
                        <v-col class="prepare-item-cell">
                            <div class="label">预估佣金</div>
                            <div class="value">{{ formatPrice(prepareItem.total_should_payout, prepareItem.currency) }}
                            </div>
                        </v-col>
                        <v-col class="prepare-item-cell">
                            <v-btn color="primary" @click="onStartPayout(prepareItem)">提现</v-btn>
                        </v-col>
                    </v-row>
                </v-list-item>
            </v-list>
            <v-dialog :value="isStartPayout" persistent width="300">
                <v-card color="primary" dark>
                    <v-card-title class="text-center">提现正在处理中</v-card-title>
                    <v-card-text>
                        <p>{{ progressTitle }}</p>
                        <v-progress-linear color="white" :value="progressValue" height="25">
                            <strong class="progress-value">{{ Math.ceil(progressValue) }}%</strong>
                        </v-progress-linear>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </v-container>
    </v-main>
</template>
  
<script>
import AppbarBackIcon from '@/components/AppbarBackIcon.vue'
import { formatPrice } from '@/plugins/price'
import { homeStore } from '@/store/home'
import { promoterPayoutStore } from '@/store/promoter/payout'

export default {
    name: 'PromoterPayoutPage',
    components: { AppbarBackIcon },
    data() {
        return {
            form: {
                dt_profit_created__lte: null,
                total_should_payout__gte: null,
            },
            prepareResult: [],
            isStartPayout: false,
            currentPrepareItem: null,
            numCreated: 0,
        }
    },
    computed: {
        prepareItemList() {
            return this.prepareResult?.item_s || []
        },
        numShouldCreate() {
            let balance_s = this.currentPrepareItem?.promoter_balance_s
            return (balance_s || []).length
        },
        progressTitle() {
            if (this.isStartPayout) {
                return `执行进度 ${this.numCreated}/${this.numShouldCreate}`
            }
            return ''
        },
        progressValue() {
            if (this.isStartPayout) {
                return (100 * this.numCreated) / this.numShouldCreate
            }
            return 0
        },
    },
    async mounted() {
        await homeStore.doLoad()
    },
    methods: {
        formatPrice,
        async onPreparePayout() {
            let result = await promoterPayoutStore.doPrepare()
            this.prepareResult = result
            if (result.item_s.length <= 0) {
                this.$toasted.info('暂无可提现收益')
            }
        },
        async onStartPayout(item) {
            const total_should_payout__gte = this.form.total_should_payout__gte
            const dt_profit_created__lte = this.form.dt_profit_created__lte
            this.currentPrepareItem = item
            this.numCreated = 0
            this.isStartPayout = true
            for (const balance of item.promoter_balance_s) {
                try {
                    await promoterPayoutStore.doCreate({
                        promoter_customer_id: balance.customer_id,
                        currency: item.currency,
                        total_should_payout__gte,
                        dt_profit_created__lte,
                    })
                } catch (ex) {
                    if (ex.code === 'PromoterPayoutUnqualified') {
                        this.$toasted.info(`推广员${balance.customer_id}暂无可提现收益`)
                    } else {
                        throw ex
                    }
                }
                this.numCreated += 1
            }
            setTimeout(() => {
                this.isStartPayout = false
                setTimeout(() => {
                    this.$router.push('/dash/promoter-payout-list')
                }, 500);
            }, 1000);
        }
    },
}
</script>
  
<style lang="less" scoped>
@import '~@/styles/common';

.content {
    border-top: solid 1px @antLineGrey;
}

.form-date {
    width: 50%;
    min-width: 300px;
    margin-left: auto;
    margin-right: auto;
    margin-top: 12px;
}

.prepare-list {
    margin-top: 24px;
}

.prepare-item {
    align-items: center;
}

.prepare-item-cell {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .label {
        color: @antTextGrey;
    }

    .value {
        font-weight: bold;
        font-size: 18px;
    }
}
</style>
